import { motion } from "framer-motion";
import BuyExtensions from "../../components/homeComponents/buy-extensions";
import GetDirection from "../../components/homeComponents/get-direction";
import NewsLetter from "../../components/homeComponents/newsletter/newsletter";
import PremiereSalon from "../../components/homeComponents/premiere-salon";
import SanDiegosSalon from "../../components/homeComponents/san-diegos-salon/san-diegos-salon";
import UrbanLuxury from "../../components/homeComponents/urban-luxury";
import { imageVariants, viewportSettings } from "../../shared/utils/animations";
import styles from "./home.module.scss";

function Home() {
  return (
    <>
      <div className={`${styles["home-container"]}`}>
        <div className={`${styles["video-container"]}`}>
          <video autoPlay muted loop playsInline preload={"auto"}>
            <source
              src="https://ik.imagekit.io/euo36lugk/meraki/Abundance-_Website_Video__UeskLrn0g.mp4?updatedAt=1685177496130"
              type="video/mp4"
            />
          </video>
        </div>
        <div className={styles["home-content"]}>
          <motion.div
            initial="imageOffScreen"
            whileInView="imageOnScreen"
            viewport={viewportSettings}
            variants={imageVariants}
          >
            <div className={`${styles["empty-box"]}`}></div>
          </motion.div>

          <motion.div
            initial="imageOffScreen"
            whileInView="imageOnScreen"
            viewport={viewportSettings}
            variants={imageVariants}
          >
            <UrbanLuxury
              url={`https://ik.imagekit.io/euo36lugk/meraki/IMG_6162_i0XAxvzKqy.PNG?updatedAt=1771290799937`}
            />
          </motion.div>
          <motion.div
            initial="imageOffScreen"
            whileInView="imageOnScreen"
            viewport={viewportSettings}
            variants={imageVariants}
          >
            <PremiereSalon />
          </motion.div>

          <motion.div
            initial="imageOffScreen"
            whileInView="imageOnScreen"
            viewport={viewportSettings}
            variants={imageVariants}
          >
            <BuyExtensions
              url={`https://ik.imagekit.io/euo36lugk/meraki/abundance%20hair%20-%20deenna%20_T1U22R5Ns.jpeg?updatedAt=1703131409217`}
            />
          </motion.div>

          <motion.div
            initial="imageOffScreen"
            whileInView="imageOnScreen"
            viewport={viewportSettings}
            variants={imageVariants}
          >
            <SanDiegosSalon />
          </motion.div>
          <motion.div
            initial="imageOffScreen"
            whileInView="imageOnScreen"
            viewport={viewportSettings}
            variants={imageVariants}
          >
            <GetDirection />
          </motion.div>

          <motion.div
            initial="imageOffScreen"
            whileInView="imageOnScreen"
            viewport={viewportSettings}
            variants={imageVariants}
          >
            <NewsLetter />
          </motion.div>
          {/* <motion.div initial="imageOffScreen" whileInView="imageOnScreen" viewport={viewportSettings} variants={imageVariants}>
                        <GetInTouch />
                    </motion.div> */}
        </div>
      </div>
    </>
  );
}

export default Home;
